'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { FormattedHTMLMessage } from 'LearningCenterUI/components/I18n';
import Professor from 'academy-shared-js/records/Professor';
import ProfessorRow from '../ProfessorRow';
import { getProfessorDescription } from '../../utils/ContentUtils';
import { getSelectedLanguageFiltersFromRoute } from '../../selectors/routeSelectors';

const ProfessorList = ({
  className,
  professors,
  i18nHeading
}) => {
  const location = useLocation();
  const languages = getSelectedLanguageFiltersFromRoute({}, {
    location
  });
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('professor-list', className),
    children: [/*#__PURE__*/_jsx("h4", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: i18nHeading,
        options: {
          count: professors.size
        }
      })
    }), professors.map(professor => /*#__PURE__*/_jsx(ProfessorRow, {
      description: getProfessorDescription(professor, languages.first()),
      id: professor.get('id'),
      image: professor.get('image'),
      linkedinUrl: professor.get('linkedinUrl'),
      name: professor.get('name'),
      twitterUrl: professor.get('twitterUrl')
    }, professor.get('id')))]
  });
};

ProfessorList.propTypes = {
  className: PropTypes.string,
  i18nHeading: PropTypes.string.isRequired,
  professors: ImmutablePropTypes.listOf(Professor).isRequired
};
export default ProfessorList;